import React, { useState, useEffect } from "react";

// Placeholder when Firebase Storage image fails (e.g. 412, expired token)
const PLACEHOLDER_SVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect fill='%23e9ecef' width='400' height='200'/%3E%3Ctext fill='%236c757d' font-family='sans-serif' font-size='14' x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle'%3EImage unavailable%3C/text%3E%3C/svg%3E";

/**
 * Renders a blog image with fallback when the URL fails (e.g. Firebase 412, expired token).
 * Use wherever blog imgUrl from Firestore is displayed.
 */
export default function BlogImage({ src, alt = "", className = "", style = {}, ...rest }) {
  const [imgSrc, setImgSrc] = useState(src);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setImgSrc(src || PLACEHOLDER_SVG);
    setErrored(false);
  }, [src]);

  const handleError = () => {
    setErrored(true);
    setImgSrc(PLACEHOLDER_SVG);
  };

  return (
    <img
      src={imgSrc || PLACEHOLDER_SVG}
      alt={alt}
      className={className}
      style={style}
      onError={handleError}
      {...rest}
    />
  );
}
